import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HistoryService {
  private historySubject = new BehaviorSubject<string[]>([]);
  historyState$ = this.historySubject.asObservable();

  updateHistory = (route: string): void => {
    const currentHistory = this.historySubject.value;
    const isSameRoute = currentHistory[currentHistory.length - 1] === route
    if (!isSameRoute) {
      this.historySubject.next([...currentHistory, route]);
    }
  }

  popHistory = (): void => {
    const currentHistory = this.historySubject.value;
    if (currentHistory.length > 0) {
      currentHistory.pop();
      this.historySubject.next([...currentHistory]);
    }
  }

  getHistory = () => {
    return this.historySubject.value;
  }
}
